import React from "react";
import {LoginHeader} from "../../Layout/Header/LoginHeader";
import AuthPage from "../AuthPage/AuthPage";
import {ChangePasswordForm} from "./ChangePasswordForm";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import {PageTitles} from "ubcommunity-shared/src/constants";

export function ChangePassword() {
    usePageTitle(PageTitles.CHANGE_PASSWORD);

    return (
        <AuthPage title={<LoginHeader title="Change Password" />}>
            <ChangePasswordForm />
        </AuthPage>
    );
}
